import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  account: null,
  storage: [],
  bucketContents: [],
  pageSize: storage.session.getItem(types.STORAGE_PAGE_SIZE) || 10,
  retrospectiveDay: storage.session.getItem(types.STORAGE_DAYS) || 0,
  searchTerm: storage.session.getItem(types.STORAGE_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.STORAGE_SORT_DIR) || 'desc',
  orderBy: storage.session.getItem(types.STORAGE_ORDER_BY) || 'Id',
  filterBy: parseInt(storage.local.getItem(types.STORAGE_FILTER_BY)) || 9999,
  filterOptions: []
})



// WEBPACK FOOTER //
// ./src/store/modules/storage/state.js